/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as DeviceRouteImport } from './routes/device'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RecoveryRouteImport } from './routes/recovery'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SharedRouteImport } from './routes/shared'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const DeviceRoute = DeviceRouteImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RecoveryRoute = RecoveryRouteImport.update({
  id: '/recovery',
  path: '/recovery',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SharedRoute = SharedRouteImport.update({
  id: '/shared',
  path: '/shared',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/connect': typeof ConnectRoute
  '/device': typeof DeviceRoute
  '/history': typeof HistoryRoute
  '/login': typeof LoginRoute
  '/recovery': typeof RecoveryRoute
  '/settings': typeof SettingsRoute
  '/shared': typeof SharedRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/connect': typeof ConnectRoute
  '/device': typeof DeviceRoute
  '/history': typeof HistoryRoute
  '/login': typeof LoginRoute
  '/recovery': typeof RecoveryRoute
  '/settings': typeof SettingsRoute
  '/shared': typeof SharedRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/connect': typeof ConnectRoute
  '/device': typeof DeviceRoute
  '/history': typeof HistoryRoute
  '/login': typeof LoginRoute
  '/recovery': typeof RecoveryRoute
  '/settings': typeof SettingsRoute
  '/shared': typeof SharedRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/connect'
    | '/device'
    | '/history'
    | '/login'
    | '/recovery'
    | '/settings'
    | '/shared'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/connect'
    | '/device'
    | '/history'
    | '/login'
    | '/recovery'
    | '/settings'
    | '/shared'
  id:
    | '__root__'
    | '/'
    | '/connect'
    | '/device'
    | '/history'
    | '/login'
    | '/recovery'
    | '/settings'
    | '/shared'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConnectRoute: typeof ConnectRoute
  DeviceRoute: typeof DeviceRoute
  HistoryRoute: typeof HistoryRoute
  LoginRoute: typeof LoginRoute
  RecoveryRoute: typeof RecoveryRoute
  SettingsRoute: typeof SettingsRoute
  SharedRoute: typeof SharedRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/device': {
      id: '/device'
      path: '/device'
      fullPath: '/device'
      preLoaderRoute: typeof DeviceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recovery': {
      id: '/recovery'
      path: '/recovery'
      fullPath: '/recovery'
      preLoaderRoute: typeof RecoveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shared': {
      id: '/shared'
      path: '/shared'
      fullPath: '/shared'
      preLoaderRoute: typeof SharedRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConnectRoute: ConnectRoute,
  DeviceRoute: DeviceRoute,
  HistoryRoute: HistoryRoute,
  LoginRoute: LoginRoute,
  RecoveryRoute: RecoveryRoute,
  SettingsRoute: SettingsRoute,
  SharedRoute: SharedRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
